export const Footer = (props) => {
    return <footer>{props.children}</footer>
}